import { UuidGenerator } from "../utilities/uuid-generator";

export class MachineUuidManager {
  private static STORE_KEY = 'machine-uuid';

  /**
   * 既存の UUID があればそれを返す。
   * なければ新規生成して保存する。
   */
  loadOrCreate(): string {
    let uuid = localStorage.getItem(MachineUuidManager.STORE_KEY);
    if (!uuid) {
      uuid = UuidGenerator.create();
      localStorage.setItem(MachineUuidManager.STORE_KEY, uuid);
    }
    return uuid;
  }

  /**
   * 原則使わない想定。
   * デバッグ・リセット用。
   */
  clear(): void {
    localStorage.removeItem(MachineUuidManager.STORE_KEY);
  }
}
